import { Typography } from 'design-system/src/components/Typography/Typography';

export interface TaskInstructionSummaryProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * A single-line text summary of the overall request in a task.
 * Used at the top of structured task views to provide context.
 */
const TaskInstructionSummary: React.FC<TaskInstructionSummaryProps> = ({ children, className }) => {
  return (
    <Typography weight={600} color="var(--grayscale-700)" className={className}>
      {children}
    </Typography>
  );
};

export default TaskInstructionSummary;
